import { Box, Skeleton, Stack } from '@mui/material'
import type { FC } from 'react'

import { COLORS, DividerWithLabel, unit } from '@hcr/ui'

import { BenefitPreviewLoading } from '../benefit-preview'

export const BenefitsGroupLoading: FC = () => {
  return (
    <Stack>
      <DividerWithLabel
        component='h2'
        bgcolor={COLORS.vaalea['60%']}
        paddingTop={unit(2.5)}
        paddingBottom={unit(2.75)}
        paddingLeft={unit(4)}
        paddingRight={unit(7)}
      >
        <Skeleton width='30%' height={unit(7)} />
      </DividerWithLabel>
      <BenefitPreviewLoading />
      <Box height={unit(2)} />
    </Stack>
  )
}
